import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "app-bottom-sheet__handle-wrap",
  "aria-hidden": "true"
};
const _hoisted_2 = {
  class: "app-bottom-sheet__body"
};
const _hoisted_3 = {
  class: "app-bottom-sheet__footer"
};
import { watch, onUnmounted, computed } from 'vue';
import { lockBodyScroll, unlockBodyScroll } from '@/composables/useBodyScrollLock';
export default {
  __name: 'AppBottomSheet',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    showHeader: {
      type: Boolean,
      default: false
    },
    showHandle: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: false
    },
    sheetClass: {
      type: String,
      default: ''
    },
    modalClass: {
      type: String,
      default: ''
    },
    closeOnClickModal: {
      type: Boolean,
      default: true
    },
    closeOnPressEscape: {
      type: Boolean,
      default: true
    },
    destroyOnClose: {
      type: Boolean,
      default: true
    },
    zIndex: {
      type: Number,
      default: undefined
    }
  },
  emits: ['update:modelValue', 'closed'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const overlayClass = computed(() => {
      const extra = String(props.modalClass || '').trim();
      return extra ? `app-bottom-sheet-overlay ${extra}` : 'app-bottom-sheet-overlay';
    });
    function onVisibleChange(next) {
      emit('update:modelValue', next);
    }
    function onClosed() {
      emit('closed');
    }
    watch(() => props.modelValue, open => {
      if (open) lockBodyScroll();else unlockBodyScroll();
    }, {
      immediate: true
    });
    onUnmounted(() => {
      if (props.modelValue) unlockBodyScroll();
    });
    return (_ctx, _cache) => {
      const _component_el_drawer = _resolveComponent("el-drawer");
      return _openBlock(), _createBlock(_component_el_drawer, {
        "model-value": __props.modelValue,
        direction: "btt",
        size: "auto",
        "with-header": __props.showHeader,
        title: __props.title,
        class: _normalizeClass(['app-bottom-sheet', __props.sheetClass]),
        "modal-class": overlayClass.value,
        "append-to-body": "",
        "lock-scroll": false,
        "close-on-click-modal": __props.closeOnClickModal,
        "close-on-press-escape": __props.closeOnPressEscape,
        "show-close": __props.showClose,
        "destroy-on-close": __props.destroyOnClose,
        "z-index": __props.zIndex,
        "onUpdate:modelValue": onVisibleChange,
        onClosed: onClosed
      }, _createSlots({
        default: _withCtx(() => [__props.showHandle ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [_createElementVNode("span", {
          class: "app-bottom-sheet__handle"
        }, null, -1)]))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "default")])]),
        _: 2
      }, [_ctx.$slots.footer ? {
        name: "footer",
        fn: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_renderSlot(_ctx.$slots, "footer")])]),
        key: "0"
      } : undefined]), 1032, ["model-value", "with-header", "title", "class", "modal-class", "close-on-click-modal", "close-on-press-escape", "show-close", "destroy-on-close", "z-index"]);
    };
  }
};